module.exports = __webpack_public_path__ + "static/CMF-logo-836e80938f8dd16fbf861ddfd4570f7b.jpg";